//Template config options
let baseUrl = "http://10.203.10.9:3000/v1"
let baseUrlColab = "http://10.203.10.18:4007/v1"

switch (window.location.hostname) {
  case "localhost":
    baseUrl = "http://localhost:3001/v1"
    baseUrlColab = "http://localhost:4007/v1"
    break
  case "10.203.10.9":
    baseUrl = "http://10.203.10.9:3000/v1"
    baseUrlColab = "http://10.203.10.18:4007/v1"
    break
  case "ceeavnl.nl.gob.mx":
    baseUrl = "https://CEEAVNL-api.nl.gob.mx/v1"
    baseUrlColab = "https://CEEAVNL-colab.nl.gob.mx/v1"
    break
}

console.log("visiting from:", window.location.hostname)
const themeConfig = {
  app: {
    appName: "CEEAV",
    appLogoImage: require("@src/assets/images/logo/logo3.png").default,
    baseUrl, //PRODUCCION
    // baseUrl: 'http://10.5.0.166:3000/v1'
    // baseUrl: 'http://localhost:3001/v1',
    baseUrlColab
    // baseUrlColab: 'http://localhost:4007/v1'
    // baseUrl: 'http://netrunner.servegame.com:4000/v1'
  },
  layout: {
    isRTL: false,
    skin: "ligth", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
